'use client';

import { getApiPrescriptionType } from '@/app/_lens-components/utils';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { EPrescriptionType } from '@/utils/enums/goods';

type TrackEventFn = (
  event: {
    eventName: string;
    properties: Record<string, any>;
  },
  providers: ProviderType[],
) => void;

export class TrackingService {
  private trackEvent: TrackEventFn;
  private lensGoodsSensorsData: Record<string, any>;
  private prescriptionType: EPrescriptionType;
  private presTypeOptionName: string;

  constructor(
    trackEvent: TrackEventFn,
    lensGoodsSensorsData: Record<string, any>,
    prescriptionType: EPrescriptionType,
    presTypeOptionName: string,
  ) {
    this.trackEvent = trackEvent;
    this.lensGoodsSensorsData = lensGoodsSensorsData || {};
    this.prescriptionType = getApiPrescriptionType(prescriptionType);
    this.presTypeOptionName = presTypeOptionName;
  }

  private track(eventName: string, additionalProperties: Record<string, any> = {}) {
    try {
      this.trackEvent(
        {
          eventName,
          properties: {
            ...this.lensGoodsSensorsData,
            prescription_type_name: this.presTypeOptionName,
            prescription_type: this.prescriptionType,
            ...additionalProperties,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.error('👀', e);
    }
  }

  prescriptionEnterPageScanEntryClick() {
    this.track('PrescriptionEnterPage_ScanEntry_Click');
  }

  prescriptionEnterPageScanPopupExp() {
    this.track('PrescriptionEnterPage_ScanPopup_Exp');
  }

  prescriptionEnterPageScanPopupFailExp() {
    this.track('PrescriptionEnterPage_ScanPopupFail_Exp');
  }

  prescriptionEnterPageScanPopupChangeExp() {
    this.track('PrescriptionEnterPage_ScanPopupChange_Exp');
  }

  prescriptionEnterPageScanPopupChangeNextClick(change_prescription_type_name?: string) {
    this.track('PrescriptionEnterPage_ScanPopupChange_Next_Click', {
      change_prescription_type_name,
    });
  }

  prescriptionScanSuccessPageView(change_prescription_type_name: string) {
    this.track('PrescriptionScanSuccessPage_View', {
      change_prescription_type_name,
    });
  }

  prescriptionEnterPageUploadSuccessResult() {
    this.track('PrescriptionEnterPage_UploadSuccess_Result');
  }

  prescriptionEnterPageScanParamResult(prescription_scan_result_type: string) {
    this.track('PrescriptionEnterPage_ScanParam_Result', {
      prescription_scan_result_type,
    });
  }

  prescriptionEnterPageScanPopupClick(btn_name: string) {
    this.track('PrescriptionEnterPage_ScanPopup_Click', {
      btn_name,
    });
  }
}
